import React from 'react';
/**
 *
 * Product Row component
 * @extends {React.Component}
 */
interface IProps {
  text?: any;
  link?:any;
  subMenu?:any
}

interface IState {
  subMenuActive:boolean;
}

class HeaderMenuItem extends React.Component<IProps>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      subMenuActive:false
    }
  }

  public toggleSubMenu = () => {
    this.setState({
      subMenuActive: this.state.subMenuActive ? false : true
    })
  }

  public render(): JSX.Element {
    let subMenuActiveClass:string = "";
    if(this.state.subMenuActive){
      subMenuActiveClass = "active";
    }
    if(!this.props.subMenu){
      return(
        <div className={"header-menu-item"}>
          <a href={this.props.link}>{this.props.text}</a>
        </div>
      )
    } else{
      return (
       <div className={"header-menu-item "+subMenuActiveClass} onMouseEnter={this.toggleSubMenu} onMouseLeave={this.toggleSubMenu}>
         <a href={this.props.link}>{this.props.text}</a>
         {this.props.subMenu &&
          <div className="header-menu-item-submenu black-background">
            {this.props.subMenu && this.props.subMenu.length > 0 && this.props.subMenu.map((item:any) =>{
              let link = '';
              if(item.linkUrl){
                if(item.linkUrl.destinationUrl){
                  link = item.linkUrl.destinationUrl;
                }
              }
              return(
                <div className={"header-menu-item-submenu-item"}>
                  <a href={link}>{item.linkText}</a>
                </div>
              )
            })}
          </div>
         }
       </div>
      );
    }
 }
}

 export default HeaderMenuItem;
